import http, { catach_url, httpCache, catchData } from './index'
catach_url.push({
    url: "/api/Account/Login",
    count: 5
})

import moment from 'moment'
import store from "@/store"

import login from "./login"

function getToken() {
    return new Promise((resove, reject) => {
        if (store.getToken) {
            debugger
            resove(store.getToken)
        } else {
            const data = {
                "loginid": "crxtpz",
                "loginpass": "202cb962ac59075b964b07152d234b70"
            }
            login(data).then(response => {
                const res = response.data;
                store.commit("setToken", res.Data.Token)
                resove(res.Data.Token)
            })
        }
    })

}


export function getPointComplete() {
    // 查询巡检完成数量
    return http.get("/AZTEST/LPResource/LPService/JKJjgisOneMap.ashx?type=pointcomplete")
}
export function getPointTotal() {
    // 巡检总数
    return http.get("/AZTEST/LPResource/LPService/JKJjgisOneMap.ashx?type=pointtotal")
}

export async function getDangerList(OptState) {
    //OptState -1 全部隐患， 1 已上报隐患
    let token = null;
    await getToken().then(response => {
        token = response
    })
    const page = 1,
        rows = 99999,
        StartTime = moment().format("YYYY") + '-01-01'
    const params = {
        token,
        page,
        rows,
        OptState,
        StartTime
    }
    const params2 = Object.keys(params).map(key => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    }).join('&')
    return http.post(`/api/Danger/List?${params2}`)
}



// WEBPACK FOOTER //
// ./src/api/api.js